<template>
  <v-container class="content-wrapper" id="equipment-tab">
    <v-row
      class="d-block"
      v-if="
        ordersPendingCurrentProvider > 0 ||
          equipmentOrdersPendingCurrentProvider > 0 ||
          patentsOrdersPendingCurrentProvider > 0
      "
    >
      <v-card elevation="3" style="border-radius: 24px;">
        <v-card-text
          v-if="
            ordersPending != null && ordersPending.filter(ord => ord.ordersCounter > 0).length !== 0
          "
        >
          <v-card-title class="header pb-2" style="text-align: left">
            Pending Services Orders for Managed Providers:
          </v-card-title>
          <v-card-text
            v-for="orderPending in ordersPending.filter(ord => ord.ordersCounter > 0)"
            :key="orderPending.provider.name"
          >
            <div>
              <v-badge color="warning" inline :content="orderPending.ordersCounter">
                {{ orderPending.provider.name }}
              </v-badge>
            </div>
          </v-card-text>
        </v-card-text>
        <v-card-text
          v-if="
            equipmentOrdersPending != null &&
              equipmentOrdersPending.filter(ord => ord.ordersCounter > 0).length !== 0
          "
          class="mt-0 pt-0"
        >
          <v-card-title class="header pb-2" style="text-align: left">
            Pending Equipment Orders for Managed Providers:
          </v-card-title>
          <v-card-text
            v-for="equipmentOrderPending in equipmentOrdersPending.filter(
              ord => ord.ordersCounter > 0,
            )"
            :key="equipmentOrderPending.provider.name"
          >
            <div>
              <v-badge color="warning" inline :content="equipmentOrderPending.ordersCounter">
                {{ equipmentOrderPending.provider.name }}
              </v-badge>
            </div>
          </v-card-text>
        </v-card-text>
        <v-card-text
          v-if="
            patentsOrdersPending != null &&
              patentsOrdersPending.filter(ord => ord.ordersCounter > 0).length !== 0
          "
          class="mt-0 pt-0"
        >
          <v-card-title class="header pb-2" style="text-align: left">
            Pending Patents Orders for Managed Providers:
          </v-card-title>
          <v-card-text
            v-for="patentOrderPending in patentsOrdersPending.filter(ord => ord.ordersCounter > 0)"
            :key="patentOrderPending.provider.name"
          >
            <div>
              <v-badge color="warning" inline :content="patentOrderPending.ordersCounter">
                {{ patentOrderPending.provider.name }}
              </v-badge>
            </div>
          </v-card-text>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row class="mt-10" justify="center">
      <v-col v-if="institutions != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Institutions
              </div>
              <div class="counter">{{ institutions }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col v-if="services != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Services
              </div>
              <div class="counter">{{ services }}</div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col v-if="equipment != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-card elevation="3" style="border-radius: 24px; width: 243px; ">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Equipment
              </div>
              <div class="counter">{{ equipment }}</div>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
      <v-col v-if="patents != null" cols="12" xl="2" lg="3" sm="12" xs="12" align="center">
        <v-card elevation="3" style="border-radius: 24px; width: 243px; ">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="header">
                Onboarded <br />
                Patents
              </div>
              <div class="counter">{{ patents }}</div>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
      <v-col
        v-if="
          ordersCompleted != null ||
            equipmentOrdersCompleted != null ||
            patentsOrderCompleted != null
        "
        cols="12"
        xl="2"
        lg="3"
        sm="12"
        xs="12"
        align="center"
      >
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px;">
            <div class="dashboard-tiles">
              <div class="header">
                Orders <br />
                Completed
              </div>
              <div class="counter">
                {{ ordersCompleted + equipmentOrdersCompleted + patentsOrderCompleted }}
              </div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
      <v-col
        v-if="
          ordersPendingCurrentProvider != null ||
            equipmentOrdersPendingCurrentProvider != null ||
            patentsOrdersPendingCurrentProvider != null
        "
        cols="12"
        xl="2"
        lg="3"
        sm="12"
        xs="12"
        align="center"
      >
        <v-scale-transition>
          <v-card elevation="3" style="border-radius: 24px; width: 243px; ">
            <div class="dashboard-tiles">
              <div class="header">
                Orders <br />
                Ongoing
              </div>
              <div class="counter">
                {{
                  ordersPendingCurrentProvider +
                    equipmentOrdersPendingCurrentProvider +
                    patentsOrdersPendingCurrentProvider
                }}
              </div>
            </div>
          </v-card>
        </v-scale-transition>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col v-if="!loadingChart1" cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
        <v-card elevation="3" style="border-radius: 24px;">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="chart-title mb-5">
                Distribution of Resources <br />
                Categories
              </div>
              <vue-apex-charts
                :height="height"
                type="donut"
                :options="chartOptions1"
                :series="series1"
              ></vue-apex-charts>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
      <v-col v-if="!loadingChart2" cols="12" xl="6" lg="12" md="12" sm="12" xs="12">
        <v-card elevation="3" style="border-radius: 24px;">
          <v-scale-transition>
            <div class="dashboard-tiles">
              <div class="chart-title mb-5">
                Distribution of Resources <br />
                Scientific Domains
              </div>
              <vue-apex-charts
                :height="height"
                type="donut"
                :options="chartOptions2"
                :series="series2"
              ></vue-apex-charts>
            </div>
          </v-scale-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'DashboardProvider',
  mixins: [util],
  components: {
    VueApexCharts,
  },
  data: () => ({
    services: null,
    equipment: null,
    patents: null,
    institutions: null,
    ordersCompleted: null,
    equipmentOrdersCompleted: null,
    patentsOrderCompleted: null,
    ordersPending: null,
    equipmentOrdersPending: null,
    patentsOrdersPending: null,
    ordersPendingCurrentProvider: null,
    equipmentOrdersPendingCurrentProvider: null,
    patentsOrdersPendingCurrentProvider: null,
    loadingChart1: true,
    series1: [],
    chartOptions1: {
      labels: [],
      legend: {
        position: 'right',
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
    loadingChart2: true,
    series2: [],
    chartOptions2: {
      labels: [],
      legend: {
        position: 'right',
      },
      responsive: [
        {
          breakpoint: 600,
          options: {
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  }),
  created() {
    let firstTime = sessionStorage.getItem('firstTime');
    if (firstTime === 'true') {
      const marketplaceServicesViewAll = true;
      const selectedCatalogue = 'Browse the Catalogue of Services';
      let routePath = '';
      routePath = '/marketplace/services';
      this.$router.push({
        path: routePath,
        query: { selectedCatalogue, marketplaceServicesViewAll },
      });
      return;
    }
    let providerId = sessionStorage.getItem('providerId');
    this.axios
      .get('/api/v1/resources/provider?providerId=' + providerId + '&size=0')
      .then(res => (this.services = res.data.total));
    this.axios
      .get('/api/v1/equipment/provider?providerId=' + providerId + '&size=0')
      .then(res => (this.equipment = res.data.total));
    this.axios
      .get('/api/v1/patent/provider?providerId=' + providerId + '&size=0')
      .then(res => (this.patents = res.data.total));
    this.axios
      .get('/api/v1/hosting-institutions/provider?providerId=' + providerId + '&size=0')
      .then(res => (this.institutions = res.data.total));
    this.axios
      .get('/api/v1/orders/count-completed-accepted?providerId=' + providerId)
      .then(res => (this.ordersCompleted = res.data));
    this.axios
      .get('/api/v1/orders-equipment/count-completed-accepted?providerId=' + providerId)
      .then(res => (this.equipmentOrdersCompleted = res.data));
    this.axios
      .get('/api/v1/orders-patent/count-completed-accepted?providerId=' + providerId)
      .then(res => (this.patentsOrderCompleted = res.data));
    this.axios
      .get('/api/v1/orders/count-pending?providerId=' + providerId)
      .then(res => (this.ordersPendingCurrentProvider = res.data));
    this.axios
      .get('/api/v1/orders-equipment/count-pending?providerId=' + providerId)
      .then(res => (this.equipmentOrdersPendingCurrentProvider = res.data));
    this.axios
      .get('/api/v1/orders-patent/count-pending?providerId=' + providerId)
      .then(res => (this.patentsOrdersPendingCurrentProvider = res.data));
    this.axios
      .get('/api/v1/orders/count-pending-by-user-provider')
      .then(res => (this.ordersPending = res.data));
    this.axios
      .get('/api/v1/orders-equipment/count-pending-by-user-provider')
      .then(res => (this.equipmentOrdersPending = res.data));
    this.axios
      .get('/api/v1/orders-patent/count-pending-by-user-provider')
      .then(res => (this.patentsOrdersPending = res.data));
    this.axios.get('/api/v1/resources/group-by-category?providerId=' + providerId).then(res => {
      this.series1 = res.data.map(sr => sr[1]);
      this.chartOptions1.labels.push(...res.data.map(sr => sr[0]));
      this.loadingChart1 = false;
    });
    this.axios.get('/api/v1/resources/group-by-scientific?providerId=' + providerId).then(res => {
      this.series2 = res.data.map(sr => sr[1]);
      this.chartOptions2.labels.push(...res.data.map(sr => sr[0]));
      this.loadingChart2 = false;
    });
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 800;
        case 'sm':
          return 800;
        case 'md':
          return 300;
        case 'lg':
          return 300;
        case 'xl':
          return 300;
        default:
          return 300;
      }
    },
  },
};
</script>
